import { removeAccountsFromOrganizationBulkActionType, } from '../../../../../../../backend/features/organizations/shared';
import { showRemoveAccountDialog } from '../../../../../../../ui/features/accounts/components/showRemoveAccountDialog';
import { getFilterForBulkAction } from '../../../../../../../utils';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
export function handleRemoveMembersFromOrganization({ t, selectedRowIds, appliedStorageFilters, rowCount, organizationId, onReloadOrganization, onReloadTable, onDeselectAllRows, }) {
    showRemoveAccountDialog({
        count: rowCount,
        t: t,
        onConfirm: () => {
            launchBulkAction({
                type: removeAccountsFromOrganizationBulkActionType,
                title: t('forms.orgMembers.removingAccounts'),
                params: {
                    organizationId,
                    filter: getFilterForBulkAction(selectedRowIds, appliedStorageFilters),
                },
                onClose: () => {
                    onDeselectAllRows === null || onDeselectAllRows === void 0 ? void 0 : onDeselectAllRows();
                    onReloadOrganization();
                    onReloadTable();
                },
            });
        },
    });
}
